import { Typography } from '@plum-xoxo/admin-dsm';
import moment from 'moment';
import React from 'react'
import theme from '../../../../theme/theme';

const statusMapping = {
    'REWARD_SENT': 1,
    'REWARD_RESENT': 2,
    'EMAIL_DELIVERED': 3,
    'SMS_DELIVERED': 4,
    'EMAIL_FAILED': 5,
    'SMS_FAILED': 6
}

const TimelineDetail = ({ type, created_at, failed }) => {
    return created_at ? <div className="d-flex justify-content-between pt-8">
        <Typography.BodySmall
            color={!failed ? "green" : "red"}
            shade="c300"
            component="div"
        >
            {!failed ? `${type} Delivered` : `${type} Delivery Failed`}
        </Typography.BodySmall>
        <Typography.BodySmall
            color="dark"
            shade="c200"
            className="ml-auto"
            component="div"
        >
            {!failed ? moment(created_at).format("MMM D, YYYY") : ""}
        </Typography.BodySmall>
</div>: ""
};

const ActivityTimeline = ({ timeline, deliveryMethod }) => {

    const status = {}
    for (let i = 0; i < timeline.length; i++) {
        status[timeline[i]?.status || 0] = timeline[i]?.created_at;
    }

    return <>
        <div className="d-flex align-items-center">
            <div style={{
                width: 8,
                height: 8,
                borderRadius: 100,
                backgroundColor: theme.palette.primary.c02
            }}></div>
            <Typography.LabelText
                color="dark"
                shade="c300"
                className="ml-10"
            >
                {status[statusMapping.REWARD_SENT] ? "Reward Sent" : "Reward Resent"}

            </Typography.LabelText>
            <Typography.BodySmall
                color="dark"
                shade="c200"
                className="ml-auto"
                component="div"
            >
                {moment(status[statusMapping.REWARD_SENT] || status[statusMapping.REWARD_RESENT]).format("MMM D, YYYY")}
            </Typography.BodySmall>
        </div>
        <div className="pl-14 pb-22 ml-4" style={{
            borderLeft: `1px solid ${status[statusMapping.REWARD_SENT] ? "transparent" : theme.palette.base.c01}`
        }}>
            {(deliveryMethod === 1 || deliveryMethod === 3) && <TimelineDetail type="Email" created_at={status[statusMapping.EMAIL_DELIVERED]} />}
            {(deliveryMethod === 2 || deliveryMethod === 3) && <TimelineDetail type="SMS" created_at={status[statusMapping.SMS_DELIVERED]} />}

            {(deliveryMethod === 1 || deliveryMethod === 3) && <TimelineDetail type="Email" created_at={status[statusMapping.EMAIL_FAILED]} failed />}
            {(deliveryMethod === 2 || deliveryMethod === 3) && <TimelineDetail type="SMS" created_at={status[statusMapping.SMS_FAILED]} failed />}
        </div>
    </>
}

export default ActivityTimeline